export const convertPriceStringToFloat = (price: string): number => {
  /**
   * It's used to remove dollar sign from input string, and keep only the number and dot(.)
   *Example string: "$4.99" will be turned into 4.99
   */
  const NON_NUMERIC_MATCHER = /[^\d^.]+/g;
  return parseFloat(JSON.stringify(price).replace(NON_NUMERIC_MATCHER, ''));
};

const isValidRefundInputValues = (originalItemPrice: number, originalItemTax: number, exchangeItemPrice: number, promoAmount: number): boolean =>
  originalItemPrice > 0 && originalItemTax >= 0 && promoAmount <= 0 && exchangeItemPrice > 0;

export default (
  originalItemPrice: number,
  originalItemTax: number,
  exchangeItemPriceData: string | number,
  promoAmount: number
): { refund: string; estimatedTax: string } => {
  const exchangeItemPrice = typeof exchangeItemPriceData === 'number' ? exchangeItemPriceData : convertPriceStringToFloat(exchangeItemPriceData);
  if (!isValidRefundInputValues(originalItemPrice, originalItemTax, exchangeItemPrice, promoAmount)) {
    return { refund: '0', estimatedTax: '0' };
  }

  // promoAmount is negative number, e.g. -5.00
  const originalItemPriceWithPromos = originalItemPrice + promoAmount;
  // if new item price is higher, we don't calculate the refund and tax
  if (exchangeItemPrice > originalItemPriceWithPromos || originalItemPriceWithPromos <= 0) {
    return { refund: '0', estimatedTax: '0' };
  }
  // if new item price is even, we don't calculate the refund and use original tax
  if (exchangeItemPrice === originalItemPriceWithPromos) {
    return { refund: '0', estimatedTax: originalItemTax.toFixed(2) };
  }
  // if new item price is less, we calculate the refund and tax for new item
  const exchangeItemTax = (originalItemTax * exchangeItemPrice) / originalItemPriceWithPromos;
  const refund = (originalItemPriceWithPromos + originalItemTax - exchangeItemPrice - exchangeItemTax).toFixed(2);
  return { refund, estimatedTax: exchangeItemTax.toFixed(2) };
};
